import React from "react";
import ReactDOM from "react-dom/client";
import "../src/styles/index.css";
import App from "./components/App";
import reportWebVitals from "./reportWebVitals";
import { Provider } from "react-redux";
import { configureStore } from "@reduxjs/toolkit";
import rootReducer from "./rootReducer";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Error404 from "./components/screens/Errors/Error404";
import InvitationFail from "./components/screens/Errors/InvitationFail";
import { datadogLogs } from "@datadog/browser-logs";

const store = configureStore({ reducer: rootReducer });

const root = ReactDOM.createRoot(document.getElementById("root"));

datadogLogs.init({
  clientToken: process.env.REACT_APP_DATADOG_CLIENT_TOKEN_DEV,
  site: process.env.REACT_APP_DATADOG_SITE,
  service: "WebID-Logs",
  forwardErrorsToLogs: true,
  sampleRate: 100,
});

datadogLogs.logger.log("Datadog in whitelabel-webid initialized successfully", {
  status: "info",
  category: "initialization",
});

root.render(
  <React.StrictMode>
    <Provider store={store}>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<App />} />
          <Route path="*" element={<Error404 />} />
          <Route path="/invitationFail" element={<InvitationFail />} />
        </Routes>
      </BrowserRouter>
    </Provider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
